import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Card, List, ListItem, Typography } from "@mui/material";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabsInteraktCloud() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Card>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label="Pre-Requisites"
              {...a11yProps(0)}
              sx={{
                backgroundColor: "white",
                borderRadius: 1,
                "&:hover": {
                  backgroundColor: "white",
                },
                "&.Mui-selected": {
                  backgroundColor: "white",
                },
              }}
            />
            <Tab
              label="How to Register a number"
              {...a11yProps(1)}
              sx={{
                backgroundColor: "white",

                borderRadius: 1,
                "&:hover": {
                  backgroundColor: "white",
                },
                "&.Mui-selected": {
                  backgroundColor: "white",
                },
              }}
            />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <List sx={{ listStyleType: "disc", pl: 2.5 }}>
            <ListItem sx={{ display: "list-item", fontSize: "14px" }}>
              Have admin access to your company Meta Business Portfolio Account.
              If you don't have Meta Business Portfolio Account, you will have a
              provision to create new business portfolio account in Step 3.
            </ListItem>
            <ListItem sx={{ display: "list-item", fontSize: "14px" }}>
              A mobile number which is not registered on WhatsApp or WhatsApp
              Business Account. If you want to use the number which is already
              registered, you have to delete the WhatsApp or WhatsApp Business
              Account associated with that number.
            </ListItem>
          </List>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <List sx={{ listStyleType: "disc", pl: 2.5 }}>
            <ListItem sx={{ display: "list-item", fontSize: "14px" }}>
              Click on "Connect Facebook Account".
            </ListItem>
            <ListItem sx={{ display: "list-item", fontSize: "14px" }}>
              You will be taken to Facebook, complete the steps as guided by
              Facebook Pop Up. You will be redirected back here to continue with
              further steps.
            </ListItem>
            <ListItem sx={{ display: "list-item", fontSize: "14px" }}>
              Wait for 3 mins and Click on Sync button to get the phone number
              ID synchronized with Meta Server.
            </ListItem>
          </List>
          <Typography variant="subtitle2" color="text.secondary">
            With this, you have successfully registered the number as a WhatsApp
            Business API Number.
          </Typography>
        </CustomTabPanel>
      </Box>
    </Card>
  );
}
